import request from './request';
//客户接口

// 客户 >> 客户信息
export function getUserToInfo(data) {
  return request({
    url: `/customer/index`,
    method: 'get',
    data
  })
}

// 客户 >> 客服列表
export function getUserTokefuList(data) {
  return request({
    url: `/customer/cs`,
    method: 'get',
    data
  })
}

// 客户 >> 查看当前用户所有站和所有客服
export function getUserAllList(customer_id) {
  return request({
    url: `/customer/cs_and_site?cus_id=${customer_id}`,
    method: 'get',
  })
}

// 客户 >> 分配客服给网站
export function setKefuToSite(data) {
  return request({
    url: `/customer/link_cs_site`,
    method: 'post',
    data
  })
}

// 获取
export function getBlackList(data) {
  return request({
    url: `/api/IMAPI/getBlackList`,
    method: 'get',
    data
  })
}

// 获取访问日志 - 访客信息（经纬度等）
export function GetVisitLog(uid) {
  return request({
    url: `/api/IMAPI/GetVisitLog?uid=${uid}`,
    method: 'get',
  })
}

// 修改房间留资
export function SetVisitorLz(data) {
  return request({
    url: `/chatlog/visitor_lz`,
    method: 'get',
    data
  })
}

// 拉黑
export function Block(data) {
  return request({
    url: `/api/IMAPI/Block`,
    method: 'get',
    data,
  })
}

// 解封
export function unBlock(data) {
  return request({
    url: `/api/IMAPI/unBlock`,
    method: 'get',
    data,
  })
}